export function sharedUtilsValidators(): string {
  return 'shared-utils-validators';
}
